import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/carousel';

export default class Main {
    constructor() {

    }
}